export default __webpack_public_path__ + "static/media/gallery1.9f94c382.jpg";